$("a[href^='#']").on("click", function (e) {
  var href = $.attr(this, "href");
  if (href == "#") return;

  if ((target = $(href).get(0))) {
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top,
      },
      500
    );
  }
});
